import React from 'react';
import { Paper, PaperBorderType } from '@roc/ui';
import { Typography, Box, Grid, List, makeStyles, Theme, lighten } from '@material-ui/core';
import { formatCurrency, isNil } from '@roc/ui/utils';
import { observer } from 'mobx-react';

const useStyles = makeStyles((theme: Theme) => ({
  totalRow: {
    background: lighten(theme.palette.primary.main, 0.9),
    borderBottom: 'none !important',
  },
  cellText: {
    fontWeight: "bold",
    lineHeight: '35px',
  },
}));

export const PayoffReconciliationFinalCard = observer(({store}) => {
  const classes = useStyles();
  const divider = <Box my={1} borderBottom={1} borderColor="grey.300" />;
  const listItem = (label, value) => (
    <Box display="flex" justifyContent="space-between" py={0.5}>
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2" color="textSecondary">{value}</Typography>
    </Box>
  );

  return (
    <Paper titleComponent={
      <Box display="flex" p={2}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h5">
              Final
            </Typography>
          </Grid>
        </Grid>
      </Box>
    } borderType={PaperBorderType.SOLID_BORDER} style={{ width: '50%'}}>
      <Box p={2}>
        <Grid container style={{ padding: '0px 16px 16px' }} spacing={2}>
          <Grid item xs={12}>
            <List style={{ padding: '0px' }}>
              {listItem('Unpaid Balance', store?.sectionTotals && !isNil(store.sectionTotals[0]?.amount) ? formatCurrency(store.sectionTotals[0].amount) : '-')}
              {divider}
              {listItem('Payoff Summary', store?.sectionTotals && !isNil(store.sectionTotals[1]?.amount) ? formatCurrency(store.sectionTotals[1].amount) : '-')}
              {divider}
              {listItem('Unpaid Interest', store?.sectionTotals && !isNil(store.sectionTotals[2]?.amount) ? formatCurrency(store.sectionTotals[2].amount) : '-')}
              {divider}
              {listItem('Servicer Fees', store?.sectionTotals && !isNil(store.sectionTotals[3]?.amount) ? formatCurrency(store.sectionTotals[3].amount) : '-')}
              {divider}
              {listItem('Unpaid Charges', store?.sectionTotals && !isNil(store.sectionTotals[4]?.amount) ? formatCurrency(store.sectionTotals[4].amount) : '-')}
              {divider}
              <b>{listItem('Total', !isNil(store?.finalTotal) ? formatCurrency(store?.finalTotal) : '-')}</b>
            </List>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
});
